import { ModalRouteHash } from 'components/base-components/ModalRouter/modal-route-hash';

export default function openPOItemsProd(push) {
  return () => {
    push(ModalRouteHash.PurchaseOrderProd);
  };
}
